import { User } from '../digigov/dg_core/header/header.component';

export const getRoleBasedRoute = (userData: User): string => {
  let route = '';
  /*
  
  YOU CAN WRITE YOUR ARPPLICATION SPECIFIC ROLEBASED ROUTING CODE HERE
  const roleIdList = userData.groupIds;  // YOU CAN GET LOGGEDIN USER ROLES USING THIS
  
  eg. YOU WANT THAT IF USER HAS 2526277 THIS ROLE ID THEN YOU WANT TO REDIRECT TO '/admin'
      then write code to get that condition and 
      return '/admin' --as function output

   */

  return route;
};
